export default {"src":"/_next/static/media/nutritional deficiencies.66c0574d.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};